import React from 'react';
import { BillOfLading } from 'src/components/BillOfLading';
import { CarrierLogo } from 'src/components/RatePicker';
import invoiceImage from 'src/images/invoice.svg';
import {
  Button,
  Card,
  CardBody,
  Col,
  Icon,
  Row,
  useApp
} from 'straightline-ui';
import { isLTL } from 'straightline-utils/constants';
import { formatDistanceToNowStrict } from 'straightline-utils/time';

export default function BOL({ shipment }) {
  let isReady = !!shipment.carrier_id && !!shipment.shipment_dispatch;
  if (isReady && isLTL(shipment)) {
    isReady =
      !!shipment.shipment_dispatch.carrier_pro_number ||
      !!shipment.shipment_dispatch.carrier_trailer_number;
  }

  if (!isReady) {
    return (
      <Row>
        <Col xl="4" className="order-xl-2">
          <Card className="">
            <CardBody>
              <div className="">
                This shipment is still awaiting some dispatch details from the
                carrier or driver. The BOL will be available after the dispatch
                has been confirmed.
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl="8">
          <div
            className="shadow-sm rounded"
            style={{
              opacity: 0.4,
              width: '100%',
              overflow: 'hidden',
              maskImage:
                'linear-gradient(to bottom, black 50%, transparent 100%)'
            }}
          >
            <img
              src={invoiceImage}
              style={{ width: '100%' }}
              alt="No Results"
            />
          </div>
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col xl="4" className="order-xl-2">
        <Instructions shipment={shipment} />
      </Col>
      <Col xl="8">
        <Card>
          <CardBody className="p-2">
            <BillOfLading shipment={shipment} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

function Instructions({ shipment }) {
  const app = useApp();

  const { result: bolDocument } = app
    .service('api/shipment-documents')
    .useGet('bol', {
      query: {
        shipment_id: shipment.id
      }
    });

  const { carrier, rate } = shipment;

  const validMC =
    carrier.mc_number &&
    carrier.mc_number.length &&
    carrier.mc_number !== '00000000';

  return (
    <Card>
      <CardBody className="border-bottom">
        <Row className="d-flex justify-content-between mb-2">
          <Col className="mb-1">
            <div className="h3 mb-0 d-flex align-items-center">
              <Icon type="dollar-sign" className="mr-3"></Icon>Bill Of Lading
            </div>
          </Col>
          <Col className="col-auto mb-1">
            <div className="mb-0 text-secondary">
              Updated {formatDistanceToNowStrict(shipment.updated_at)}
            </div>
          </Col>
        </Row>
        <div className="">
          <div className="mb-3">
            Download the BOL. The Bill of Lading includes shipper/consignee
            info, freight description, and special handling instructions.
          </div>
          <div>
            <Button
              color="primary"
              block
              tag="a"
              disabled={!bolDocument?.document.download_url}
              href={bolDocument?.document.download_url}
            >
              Download
            </Button>
          </div>
        </div>
      </CardBody>

      <CardBody>
        <div className="d-flex align-items-center">
          <div className="mr-3">
            <CarrierLogo carrier={carrier} size={35} />
          </div>
          <div className="flex-grow-1">
            <div style={{ lineHeight: 1 }}>{carrier.name}</div>
            <div className="text-secondary">{rate.service_level.name}</div>
          </div>
        </div>
        <hr />
        {validMC && (
          <>
            <div className="d-flex justify-content-between align-items-center mb-1">
              <div>MC Number</div>
              <div>{carrier.mc_number}</div>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-1">
              <div>DOT Number</div>
              <div>{carrier.dot_number}</div>
            </div>
            {carrier.scac_code && (
              <div className="d-flex justify-content-between align-items-center mb-1">
                <div>SCAC Code</div>
                <div>{carrier.scac_code}</div>
              </div>
            )}
          </>
        )}
      </CardBody>
    </Card>
  );
}
